import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import loadable from '@loadable/component'

/* Constants */
import {
  DESKTOP_COMPONENTS,
  DESKTOP_COMPONENTS_OPTIONS,
} from '../../../modules/voltran/voltranConstants'
import {FEATURE_TOGGLE_NAMES} from '../../../modules/feature-toggle/featureToggleConstants'

/* Utils */
import {checkCountryCodeForHepsiglobalModal} from '../../../components/HepsiglobalModal/hepsiglobalModalUtils'

/* Components */
import VoltranFragment from '../../../components/VoltranFragment/VoltranFragment'
import SeoContent from '../../../views/seo/content/SeoContent'

/* Loadable Components */
const HepsiglobalModal = loadable(() => import('../../../components/HepsiglobalModal/HepsiglobalModal'))
const DynamicFooter = loadable(() => import('../../../views/footer/desktop/DynamicFooter'))
const BackToTop = loadable(() => import('@cosmos/back-to-top'))

/* Configs */
import {cosmosPrefix} from '../../../appConfig'

/* Styles */
import s from './MasterLayout.scss'

const COSMOS_PREFIX = `${cosmosPrefix}-layout`
const BACK_TO_TOP_VISIBLE_POSITION = 1000

class MasterLayout extends Component {
  static propTypes = {
    className: PropTypes.string,
    routeName: PropTypes.string,
    routeChange: PropTypes.bool,
    location: PropTypes.object,
    keyword: PropTypes.string,
    children: PropTypes.any,
    count: PropTypes.number,
    type: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      loadBackToTopButton: false,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleLoadBackToTopButton)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleLoadBackToTopButton)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      routeName,
    } = this.props

    if (routeName !== prevProps.routeName) {
      // eslint-disable-next-line no-unused-expressions
      googletag?.destroySlots?.()
    }
  }

  handleLoadBackToTopButton = () => {
    const {loadBackToTopButton} = this.state

    if (loadBackToTopButton === false && window.scrollY > BACK_TO_TOP_VISIBLE_POSITION) {
      this.setState({loadBackToTopButton: true})
      window.removeEventListener('scroll', this.handleLoadBackToTopButton)
    }
  }

  isMobileAppControl() {
    const {
      location,
    } = this.props
    let urlParams = new URLSearchParams(location.search)
    let controlParams = urlParams.has('forMobileApp')
    return controlParams
  }

  render() {
    const {
      routeName,
      routeChange,
      children,
      fragmentsMap,
      serverSideRendering,
      pageFeatureToggleMap,
    } = this.props

    const {loadBackToTopButton} = this.state

    const fragments = {
      [DESKTOP_COMPONENTS.ADVERTISEMENT]: fragmentsMap?.get(
        DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.ADVERTISEMENT]?.id?.toString(),
      ),
      [DESKTOP_COMPONENTS.OLD_HEADER]: fragmentsMap?.get(
        DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.OLD_HEADER]?.id?.toString(),
      ),
      [DESKTOP_COMPONENTS.NAVIGATION_DESKTOP]: fragmentsMap?.get(
        DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.NAVIGATION_DESKTOP]?.id?.toString(),
      ),
      [DESKTOP_COMPONENTS.ADD_TO_CART]: fragmentsMap?.get(
        DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.ADD_TO_CART]?.id?.toString(),
      ),
      [DESKTOP_COMPONENTS.HEADER]: fragmentsMap?.get(
        DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.HEADER]?.id?.toString(),
      ),
      [DESKTOP_COMPONENTS.FAVORITE]: fragmentsMap?.get(
        DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.FAVORITE]?.id?.toString(),
      ),
    }

    const scriptRenderMethodClientSide = routeChange || !serverSideRendering
    const isMobileAppControl = this.isMobileAppControl()
    const showHepsiglobalModal =
      process.env.BROWSER &&
      !isMobileAppControl &&
      pageFeatureToggleMap?.get(FEATURE_TOGGLE_NAMES.DISPLAY_HEPSIGLOBAL_MODAL) &&
      checkCountryCodeForHepsiglobalModal()

    return (
      <Fragment>
        <SeoContent className={s.seoWrapper} />

        {showHepsiglobalModal && <HepsiglobalModal />}

        {!isMobileAppControl &&
          fragments[DESKTOP_COMPONENTS.ADVERTISEMENT] &&
          <section className={s.advertisementWrapper}>
            <VoltranFragment
              key={routeName}
              fragmentInfo={fragments[DESKTOP_COMPONENTS.ADVERTISEMENT]}
              options={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.ADVERTISEMENT]}
              renderMethodClientSide={scriptRenderMethodClientSide}
              removeClientStyles/>
          </section>
        }

        {!isMobileAppControl &&
          fragments[DESKTOP_COMPONENTS.HEADER] &&
          <section className={s.headerWrapper}>
            <VoltranFragment
              fragmentInfo={fragments[DESKTOP_COMPONENTS.HEADER]}
              options={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.HEADER]}
              renderMethodClientSide={scriptRenderMethodClientSide}
              removeClientStyles/>
          </section>
        }

        {!isMobileAppControl &&
          fragments[DESKTOP_COMPONENTS.OLD_HEADER] &&
          <section className={s.headerWrapper}>
            <VoltranFragment
              fragmentInfo={fragments[DESKTOP_COMPONENTS.OLD_HEADER]}
              options={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.OLD_HEADER]}
              renderMethodClientSide={scriptRenderMethodClientSide}
              removeClientStyles/>
          </section>
        }

        {!isMobileAppControl &&
          fragments[DESKTOP_COMPONENTS.NAVIGATION_DESKTOP] &&
          <section className={s.navigationWrapper}>
            <VoltranFragment
              fragmentInfo={fragments[DESKTOP_COMPONENTS.NAVIGATION_DESKTOP]}
              options={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.NAVIGATION_DESKTOP]}
              renderMethodClientSide={scriptRenderMethodClientSide}
              removeClientStyles/>
          </section>
        }

        <main className={s.main}>
          {children}
          {
            process.env.BROWSER &&
            loadBackToTopButton &&
            <BackToTop
              prefix={COSMOS_PREFIX}/>
          }
        </main>
        <DynamicFooter isMobileApp={isMobileAppControl}/>

        {
          fragments[DESKTOP_COMPONENTS.ADD_TO_CART] &&
          <VoltranFragment
            key={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.ADD_TO_CART]?.id}
            fragmentInfo={fragments[DESKTOP_COMPONENTS.ADD_TO_CART]}
            options={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.ADD_TO_CART]}
            renderMethodClientSide={scriptRenderMethodClientSide}
            removeClientStyles/>
        }

        {
          fragments[DESKTOP_COMPONENTS.FAVORITE] &&
          <VoltranFragment
            key={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.FAVORITE]?.id}
            fragmentInfo={fragments[DESKTOP_COMPONENTS.FAVORITE]}
            options={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.FAVORITE]}
            renderMethodClientSide={scriptRenderMethodClientSide}
            removeClientStyles/>
        }
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  const {
    loadState: {
      serverSideRendering,
    },
    voltranState: {
      fragmentsMap,
    },
    featureToggleState: {
      pageFeatureToggleMap,
    },
  } = state

  return {
    serverSideRendering,
    fragmentsMap,
    pageFeatureToggleMap,
  }
}

export default connect(mapStateToProps)(MasterLayout)
